import { locale } from './locales';

export const ALL_TEMPLATES_CATEGORY_MOCK = {
    id: '0',
    name: locale.ALL_TEMPLATES,
    companyNames: ['OPUS', 'SOMEDAY'],
    createdAt: '2020-10-13T10:36:29.330Z',
    updatedAt: '2020-10-13T10:36:29.330Z',
};
